<template>
    <form
        method="post"
        class="wpcf7-form init mailchimp-ext-0.5.56"
        novalidate="novalidate"
        data-status="init"
    >
        <p class="text-center text-small">
            Information published in the INC member directory.
        </p>
        <div class="d-flex justify-content-between formStepHeader">
            <h3>Company information</h3>
        </div>
        <p><br /></p>
        <div class="custom-grid">
            <div class="flex-float flex-4">
                <label>Name</label
                ><span class="wpcf7-form-control-wrap companyname"
                    ><input
                        type="text"
                        name="companyname"
                        v-model="companyModel.name"
                        size="40"
                        class="wpcf7-form-control wpcf7-text"
                        aria-invalid="false"
                /></span>
            </div>
            <div class="flex-float flex-4">
                <label>Photo</label>
                <RoundedImageInput
                    name="companyphoto"
                    @image-change="companyModel.photo = $event"
                />
            </div>
        </div>
        <div class="custom-grid">
            <div class="flex-float flex-8">
                <label>Adress</label
                ><span class="wpcf7-form-control-wrap companyadress"
                    ><input
                        type="text"
                        name="companyadress"
                        v-model="companyModel.adress"
                        size="40"
                        class="wpcf7-form-control wpcf7-text"
                        aria-invalid="false"
                /></span>
            </div>
            <div class="flex-float flex-4">
                <label>Country</label
                ><span class="wpcf7-form-control-wrap companycountry"
                    ><input
                        type="text"
                        name="companycountry"
                        v-model="companyModel.country"
                        size="40"
                        class="wpcf7-form-control wpcf7-text"
                        aria-invalid="false"
                /></span>
            </div>
        </div>
        <div class="custom-grid">
            <div class="flex-float flex-4">
                <label>Phone</label
                ><span class="wpcf7-form-control-wrap companyphone"
                    ><input
                        type="text"
                        name="companyphone"
                        v-model="companyModel.phone"
                        size="40"
                        class="wpcf7-form-control wpcf7-text"
                        aria-invalid="false"
                /></span>
            </div>
            <div class="flex-float flex-4">
                <label>Email</label
                ><span class="wpcf7-form-control-wrap companyemail"
                    ><input
                        type="text"
                        name="companyemail"
                        v-model="companyModel.email"
                        size="40"
                        class="wpcf7-form-control wpcf7-text"
                        aria-invalid="false"
                /></span>
            </div>
            <div class="flex-float flex-4">
                <label>Website</label
                ><span class="wpcf7-form-control-wrap companywebsite"
                    ><input
                        type="text"
                        name="companywebsite"
                        v-model="companyModel.website"
                        size="40"
                        class="wpcf7-form-control wpcf7-text"
                        aria-invalid="false"
                /></span>
            </div>
        </div>
        <div class="d-flex justify-content-between formStepHeader">
            <h3>Company leadership</h3>
        </div>
        <p><br /></p>
        <div class="custom-grid">
            <div class="flex-float flex-2">
                <label>Photo</label>
                <RoundedImageInput
                    name="leaderphoto1"
                    @image-change="companyModel.leader.first.photo = $event"
                />
            </div>
            <div class="flex-float flex-2">
                <label>Title</label>
                <span class="wpcf7-form-control-wrap leadertitle1">
                    <input
                        v-model="companyModel.leader.first.title"
                        type="text"
                        name="leadertitle1"
                        size="40"
                        class="wpcf7-form-control wpcf7-text"
                        aria-invalid="false"
                    />
                </span>
            </div>
            <div class="flex-float flex-4">
                <label>Name</label>
                <span class="wpcf7-form-control-wrap leadername1">
                    <input
                        v-model="companyModel.leader.first.full_name"
                        type="text"
                        name="leadername1"
                        size="40"
                        class="wpcf7-form-control wpcf7-text"
                        aria-invalid="false"
                    />
                </span>
            </div>
            <div class="flex-float flex-4">
                <label>Job title</label>
                <span class="wpcf7-form-control-wrap leaderjobtitle1">
                    <input
                        v-model="companyModel.leader.first.job_title"
                        type="text"
                        name="leaderjobtitle1"
                        size="40"
                        class="wpcf7-form-control wpcf7-text"
                        aria-invalid="false"
                    />
                </span>
            </div>
        </div>
        <div class="custom-grid">
            <div class="flex-float flex-2">
                <label>Photo</label>
                <RoundedImageInput
                    name="leaderphoto2"
                    @image-change="companyModel.leader.second.photo = $event"
                />
            </div>
            <div class="flex-float flex-2">
                <label>Title</label>
                <span class="wpcf7-form-control-wrap leadertitle2">
                    <input
                        type="text"
                        v-model="companyModel.leader.second.title"
                        name="leadertitle2"
                        size="40"
                        class="wpcf7-form-control wpcf7-text"
                        aria-invalid="false"
                    />
                </span>
            </div>
            <div class="flex-float flex-4">
                <label>Name</label>
                <span class="wpcf7-form-control-wrap leadername2">
                    <input
                        v-model="companyModel.leader.second.full_name"
                        type="text"
                        name="leadername2"
                        size="40"
                        class="wpcf7-form-control wpcf7-text"
                        aria-invalid="false"
                    />
                </span>
            </div>
            <div class="flex-float flex-4">
                <label>Job title</label>
                <span class="wpcf7-form-control-wrap leaderjobtitle2">
                    <input
                        v-model="companyModel.leader.second.job_title"
                        type="text"
                        name="leaderjobtitle2"
                        size="40"
                        class="wpcf7-form-control wpcf7-text"
                        aria-invalid="false"
                    />
                </span>
            </div>
        </div>
        <div class="custom-grid">
            <div class="flex-float flex-12">
                <label>Company description</label>
                <span class="wpcf7-form-control-wrap companydescription">
                    <textarea
                        name="companydescription"
                        cols="40"
                        rows="10"
                        class="wpcf7-form-control wpcf7-textarea"
                        aria-invalid="false"
                        v-model="companyModel.description"
                    ></textarea>
                </span>
            </div>
        </div>
        <div class="d-flex justify-content-between formStepHeader">
            <h3>Company operations details</h3>
        </div>
        <p><br /></p>
        <div class="custom-grid">
            <div class="flex-float flex-4">
                <label>Activity</label>
                <span class="wpcf7-form-control-wrap inc_companyactivity">
                    <select
                        name="inc_companyactivity"
                        class="wpcf7-form-control wpcf7-select"
                        aria-invalid="false"
                        v-model="companyModel.activity"
                    >
                        <option value="">Choose an option</option>
                        <option
                            v-for="activity in terms.activities"
                            :value="activity.name"
                        >
                            {{ activity.name }}
                        </option>
                    </select>
                </span>
            </div>
            <div class="flex-float flex-4">
                <label class="inc_companysubactivity">Sub-activity</label>
                <span class="wpcf7-form-control-wrap inc_companysubactivity">
                    <select
                        name="inc_companysubactivity"
                        class="wpcf7-form-control wpcf7-select"
                        aria-invalid="false"
                        :disabled="!select.subactivities.show"
                        v-model="companyModel.subactivity"
                    >
                        <option value="">Choose an option</option>
                        <option
                            v-for="subactivity in terms.subactivities"
                            :value="subactivity.name"
                        >
                            {{ subactivity.name }}
                        </option>
                    </select>
                </span>
            </div>
            <div class="flex-float flex-4">
                <label>Turnover</label>
                <span class="wpcf7-form-control-wrap companyturnover">
                    <select
                        name="companyturnover"
                        class="wpcf7-form-control wpcf7-select"
                        aria-invalid="false"
                        v-model="companyModel.turnover"
                    >
                        <option value="">---</option>
                        <option value="Less than 2M EUR">
                            Less than 2M EUR
                        </option>
                        <option value="2M EUR to 10M EUR">
                            2M EUR to 10M EUR
                        </option>
                        <option value="10M EUR to 50M EUR">
                            10M EUR to 50M EUR
                        </option>
                        <option value="50M EUR to 200M EUR">
                            50M EUR to 200M EUR
                        </option>
                        <option value="200M EUR to 400M EUR">
                            200M EUR to 400M EUR
                        </option>
                        <option value="400M EUR to 700M EUR">
                            400M EUR to 700M EUR
                        </option>
                        <option value="700M EUR to 1,0000M EUR">
                            700M EUR to 1,0000M EUR
                        </option>
                        <option value="More than 1,0000M EUR">
                            More than 1,0000M EUR
                        </option>
                    </select>
                </span>
            </div>
        </div>
        <div class="custom-grid">
            <div class="flex-float flex-4">
                <div class="multiselect">
                    <div
                        class="selectBox"
                        @click="
                            select.products.expanded = !select.products.expanded
                        "
                    >
                        <label>Products</label><br />
                        <select>
                            <option>{{ select.products.placeholder }}</option>
                        </select>
                        <p></p>
                        <div class="overSelect"></div>
                    </div>
                    <div
                        v-if="select.products.expanded"
                        class="false-checkboxes required expanded"
                    >
                        <span
                            class="wpcf7-form-control-wrap inc_companyproduct not-validated"
                        >
                            <span class="wpcf7-form-control wpcf7-checkbox">
                                <span
                                    v-for="(product, index) in terms.products"
                                    :class="{ first: index === 0 }"
                                    class="wpcf7-list-item"
                                >
                                    <label v-if="product.name">
                                        <input
                                            type="checkbox"
                                            class="inc_companyproduct"
                                            v-model="companyModel.products"
                                            name="inc_companyproduct[]"
                                            :value="product.name"
                                        />
                                        <span class="wpcf7-list-item-label">{{
                                            product.name
                                        }}</span>
                                    </label>
                                </span>
                            </span>
                        </span>
                    </div>
                    <input
                        name="inc_companyproduct_other"
                        type="text"
                        value=""
                        placeholder="Other product/s"
                        class="inc_companyproduct_other hidden"
                    />
                </div>
            </div>
            <div class="flex-float flex-4">
                <label>Employees</label>
                <span class="wpcf7-form-control-wrap companyemployees">
                    <select
                        name="companyemployees"
                        class="wpcf7-form-control wpcf7-select"
                        aria-invalid="false"
                        v-model="companyModel.employees"
                    >
                        <option value="">---</option>
                        <option value="1-10">1-10</option>
                        <option value="10-50">10-50</option>
                        <option value="50-250">50-250</option>
                        <option value="250-1000">250-1000</option>
                        <option value="1000-3500">1000-3500</option>
                        <option value="+3500">+3500</option>
                    </select>
                </span>
            </div>
            <div class="flex-float flex-4">
                <label>Brands</label>
                <span class="wpcf7-form-control-wrap companybrandname">
                    <input
                        type="text"
                        name="companybrandname"
                        v-model="companyModel.brandname"
                        size="40"
                        class="wpcf7-form-control wpcf7-text"
                        aria-invalid="false"
                    />
                </span>
            </div>
        </div>
        <div class="custom-grid">
            <div class="flex-float flex-4">
                <label>INC Relationship</label>
                <span class="wpcf7-form-control-wrap companyrelationship">
                    <select
                        name="companyrelationship"
                        class="wpcf7-form-control wpcf7-select"
                        aria-invalid="false"
                        v-model="companyModel.relationship"
                    >
                        <option value="">---</option>
                        <option
                            v-for="relationship in terms.relationships"
                            :value="relationship.name"
                        >
                            {{ relationship.name }}
                        </option>
                    </select>
                </span>
            </div>
        </div>
        <div class="text-center">
            <input
                type="submit"
                value="INC verification"
                class="wpcf7-form-control wpcf7-submit submit-btn"
                style="display: none"
            />
            <span class="ajax-loader"></span>
            <span class="btn-container btn-container-js">
                <a
                    @click="submit"
                    id="btSubmit"
                    href="#"
                    :class="{ disabled: form.disableSubmit }"
                    class="custom-link btn btn-lg border-width-0 btnCustom0 btn-default btn-icon-left submit-btn js custom-btn"
                    >Send</a
                >
            </span>
        </div>
        <p class="text-center text-small">
            *INC must approve changes to your profile in accordance with
            <a href="#">Terms &amp; Conditions</a>
        </p>
        <div class="wpcf7-response-output" aria-hidden="true">
            {{ form.status }}
        </div>
    </form>
</template>

<script>
import { getAllTerms } from "@/helpers/inc-members";
import RoundedImageInput from "@/components/common/form/rounded-image-input.vue";
import { requestStatusMessage, formRequest } from "@/helpers/wordpress";
import { deepCopyObject } from "@/helpers/runtime";
import { contactModelDefaults } from "@/helpers/user";

function firstCategoryToString(categories) {
    if (!Array.isArray(categories)) {
        categories = [];
    }

    const category = categories.shift();

    if (category) {
        return category.name;
    }

    return "";
}

function companyContactOffset(contacts, index) {
    if (contacts.length > index) {
        return contacts[index];
    }

    return contactModelDefaults();
}

const categoriesStringArray = (categories) =>
    categories.map((category) => category.name);
let originalTerms = {};

export default {
    props: {
        company: Object,
    },
    data() {
        return {
            terms: {
                countries: [],
                relationships: [],
                activities: [],
                subactivities: [],
                products: [],
            },
            select: {
                products: {
                    expanded: false,
                    placeholder: "Please choose an option",
                },
                subactivities: {
                    show: false,
                },
            },
            companyModel: this.updateCompanyModel(this.company),
            form: {
                status: "",
                disableSubmit: false,
            },
        };
    },
    mounted() {
        getAllTerms().then((terms) => {
            this.terms = terms;
            originalTerms = deepCopyObject(this.terms);
        });
    },
    methods: {
        async submit(event) {
            event.preventDefault();

            this.form.disableSubmit = true;
            this.form.status = "";

            const data = new FormData();

            for (let field in this.companyModel) {
                if (field !== "leader") {
                    data.append(field, this.companyModel[field]);
                }
            }

            for (let position in this.companyModel.leader) {
                for (let field in this.companyModel.leader[position]) {
                    data.append(
                        `leader[${position}][${field}]`,
                        this.companyModel.leader[position][field]
                    );
                }
            }

            const response = await formRequest(
                "POST",
                "inc_members_send_company_public_changes",
                data
            );
            this.form.status = await requestStatusMessage(response);
            this.form.disableSubmit = false;
        },
        updateCompanyModel(company) {
            return {
                name: company.post.post_title || "",
                adress: company.fields.address || "",
                country: company.categories.countries
                    .map((t) => t.name)
                    .join(", "),
                phone: company.fields.telephone || "",
                email: company.fields.email || "",
                website: company.fields.website || "",
                description: company.post.post_content || "",
                activity: firstCategoryToString(company.categories.activities),
                subactivity: firstCategoryToString(
                    company.categories.subactivities
                ),
                turnover: "",
                products: categoriesStringArray(company.categories.products),
                employees: "",
                brandname: "",
                relationship: firstCategoryToString(
                    company.categories.relationships
                ),
                photo: null,
                leader: {
                    first: companyContactOffset(company.contacts, 0),
                    second: companyContactOffset(company.contacts, 1),
                },
            };
        },
    },
    watch: {
        company: {
            handler(newValue) {
                this.companyModel = this.updateCompanyModel(newValue);
            },
            deep: true,
        },
        "companyModel.activity"(newValue) {
            const activity = this.terms.activities
                .filter((activity) => activity.name === newValue)
                .shift();
            this.companyModel.subactivity = "";

            if (!activity) {
                this.select.subactivities.show = false;
                return;
            }

            this.terms.subactivities = originalTerms.subactivities.filter(
                (subactivity) => subactivity.parent === activity.term_id
            );
            this.select.subactivities.show =
                this.terms.subactivities.length > 0;
        },
        "companyModel.products"() {
            const checkboxes = document.querySelectorAll(
                ".inc_companyproduct:checked"
            );

            if (checkboxes.length > 0) {
                this.select.products.placeholder = `${checkboxes.length} items selected`;
            } else {
                this.select.products.placeholder = "Please choose an option";
            }
        },
    },
    components: {
        RoundedImageInput,
    },
};
</script>

<style scoped>
.false-checkboxes {
    display: block;
}
</style>
